var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"back j-click-back",on:{"click":_vm.backToHome}},[_c('em',{staticClass:"back-ico"}),_vm._v(_vm._s(_vm.letter.backToPay)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }